import AXIOS from '@/utils/$axios';

export const createProject = payload =>
    AXIOS.post('/space/project/project/temp', payload);

// 抢先体验版安装包下载地址
export const getPackage = payload =>
    AXIOS.post('/lws/install-package/get-trial-version', payload);
